export const projects = [
  {
    title: "Anime Hunter",
    description:
      `Anime searches made easy! You can count on your Anime Hunter's Guild for the best info for your quarry!`,
    details: `Keeping practice with Async JavaScript, I decided to make an
      anime-search site to be proud of. It utilizes info gained from fetch calls
      to RapidAPI (namely Anime-DB). I also built in a function to save titles
      to the client's local storage to keep track of anime the user finds
      interesting.`,
    timeLine: `This project took me less than a week to complete (8/2023).`,
    techUsed: "JAVASCRIPT, HTML, CSS, REACT, REST API, AXIOS",
    image: require("../images/projectPics/anime_hunter.png"),
    site: "https://animehunterguild.netlify.app",
    githubLink: "https://github.com/OSharpe001/anime_hunter",
    position: "right"
  },
  {
    title: "Little Lemon",
    description:
      "My rendition of a bistro's website, complete with online ordering for delivery.",
    timeLine: `This project took me a week for the MVP and just over a month to complete my personal additions (2/2023 - 2/2023).`,
    details: `A capstone project from Meta's React course that I just had to flesh out! They only wanted the home and reservations pages but I knew I could do so much more. Just looking at it is making me hungry! 😅`,
    techUsed: "JAVASCRIPT, HTML, CSS, REACT",
    image: require("../images/projectPics/little_lemon1.png"),
    site: "https://littlelemonbistro.vercel.app",
    githubLink: "https://github.com/OSharpe001/little-lemon",
    position: "right"
  },
  // {
  //   title: "Dev Squared",
  //   description:
  //     `Dev Squared is a developer's greatest asset for development! Create
  //     new blogs and document your experience for the progeny!`,
  //   details: `Dev Squared is another self-challenge project that had to be
  //     tackled as soon as I learned how to incorporate a back-end to my
  //     JavaScript apps. I faced seemingly un-ending CORS issues during this app's
  //     creation. It seriously had me tapping and calling for "Uncle" 😅! I still
  //     hold deep dreams and aspirations for this blogging site...`,
  //   timeLine: `This project is currently ongoing (9/2023 - Present).`,
  //   techUsed: "JAVASCRIPT, HTML, CSS, MONGODB, EXPRESS, REACT, NODE, REST API, AXIOS,",
  //   image: require("../images/projectPics/dev_squared.png"),
  //   site: "https://devsquared-9dbdb24d78db.herokuapp.com",
  //   githubLink: "https://github.com/OSharpe001/dev_squared_app",
  //   position: "center"
  // },
  {
    title: "Pokemon Memory Match Game",
    description:
      `A tournament-style, card memory-match game that's fun for all ages!`,
    details: `My first project after learning to manipulate the DOM using
      "Vanilla JavaScript"... It utilizes random Pokemon images through fetch
      requests to PokeAPI and keeps track of the current tournament's player
      info and score using the client's local storage.`,
    timeLine: `This project took me a week and a half to complete (6/2023 - 7/2023).`,
    techUsed: "JAVASCRIPT, HTML, CSS, REST API",
    image: require("../images/projectPics/poke_memory_match.png"),
    site: "https://osharpe001.github.io",
    githubLink: "https://github.com/OSharpe001/OSharpe001.github.io",
    position: "right"
  },
  {
    title: "Letter to Success",
    description:
      `My rendition of "Wheel of Fortune! A great way to wind-down after a
      busy day of coding.`,
    details: `My first vanity project after learning React. It was an idea
      from when I first started learning programming and I finally felt ready
      to tackle it, "head-on"!`,
    timeLine: `This project took me a month and a week to complete the MVP. I'm starting to refactor and improve the site, again. (2/2023 - Current).`,
    techUsed: "JAVASCRIPT, HTML, CSS, REACT",
    image: require("../images/projectPics/letter_to_success.png"),
    site: "https://lettertosuccess.netlify.app",
    githubLink: "https://github.com/OSharpe001/letter-to-success",
    position: "right"
  },
  // {
  //   title: "Our Tip Calculator",
  //   description:
  //     "An intuitive tip calculator for any occasion.",
  //     details: `NOT FILLED IN, AS YET...`,
  //     techUsed: "",
  //   image: require("../images/projectPics/our_tip_calculator.png"),
  //   site: "https://ourtipcalculator.netlify.app",
  //   githubLink: "https://github.com/OSharpe001/myTipCalculator",
  //   position: "right"
  // },
  // {
  //   title: "The Sharpe Pages",
  //   description:
  //     'My first full-stack "CRUD-app" (2021)! Although it may need visual polishing, it is fully functional.',
  //   details: "",
  //   techUsed: "",
  //   image: require("../images/sharpe_pages.png"),
  //   site: "https://osharpe.pythonanywhere.com",
  //   githubLink: null,
  //   position: "right"
  // },
  // {
  //   title: "More to Come",
  //   description: "JUST LIKE A BIG CITY,. . . I KEEP ON BUILDING!",
  //   details: `I'll keep on building!`,
  //   techUsed: "The latest technologies",
  //   image: require("../images/projectPics/build_higher.jpeg"),
  //   site: null,
  //   githubLink: null,
  //   position: "right"
  // },
];